module.exports = __webpack_public_path__ + "img/a1.aec43f42.png";